// import React from "react";
// import {
//   Box,
//   Dialog,
//   DialogContent,
//   Typography,
//   Divider,
//   Stack,
//   Chip,
//   Button,
//   Paper,
//   IconButton,
//   Grid,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// import { WSIcons } from "../../../commonFunctions/iIcons";

// interface Props {
//   open: boolean;
//   onClose: () => void;
// }

// const PaymentDetails: React.FC<Props> = ({ open, onClose }) => {
//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 3,
//           maxHeight: "90vh",
//         },
//       }}
//     >
//       {/* Close Button */}
//       <IconButton
//         onClick={onClose}
//         sx={{ position: "absolute", top: 12, right: 12, zIndex: 10 }}
//       >
//         <WSIcons.AiOutlineCloseSquare color="red" />
//       </IconButton>

//       <DialogContent sx={{ p: 3 }}>
//         {/* Title */}
//         <Stack direction="row" justifyContent="space-between">
//           <Typography fontWeight={700}>Payment Details</Typography>
//         </Stack>

//         <Typography variant="caption" color="text.secondary">
//           #TRORD1095
//         </Typography>
//         <Chip
//           label="Paid"
//           size="small"
//           sx={{ ml: 2, color: "#098963", backgroundColor: "#CEEEE5" }}
//         />

//         <Divider sx={{ my: 2 }} />
//         {/* FIRST ROW: Patient Name (left) + Order ID (right) */}
//       <Box
//   sx={{
//     border: "1px solid #dcdcdc",
//     borderRadius: 8,
//     p: 2,
//   }}
// >
//   <Stack
//     direction="row"
//     justifyContent="space-between"
//     spacing={3}
//     sx={{ width: "100%" }}
//   >
//     {/* LEFT SIDE */}
//     <Box sx={{ flex: 1 }}>
//       <Typography color="text.secondary" fontSize={13}>
//         Patient Name
//       </Typography>
//       <Typography fontWeight={400} color="text.secondary">
//         Raghav Madhav
//       </Typography>
//     </Box>

//     {/* RIGHT SIDE */}
//     <Box sx={{ flex: 1, textAlign: "right" }}>
//       <Typography color="text.secondary" fontSize={13}>
//         Order ID
//       </Typography>
//       <Typography fontWeight={400} color="text.secondary">
//         #ORD1095
//       </Typography>
//     </Box>
//   </Stack>

//   <Divider sx={{ mt: 2, mb: 2 }} />

//   {/* Payment Info */}
//   <Stack spacing={1}>
//     <InfoRow label="Order Amount" value="₹5,000.00" />
//     <InfoRow label="Delivery Charge" value="₹40.00" />
//     <InfoRow label="Discount Applied" value="- ₹100.00" />
//     <InfoRow label="MELP Service Charge" value="- ₹50.00" />
//   </Stack>

//   <Divider sx={{ my: 2 }} />

//   <Stack direction="row" justifyContent="space-between">
//     <Typography fontWeight={400}>Final Payable to Vendor</Typography>
//     <Typography fontWeight={700}>₹4,890.00</Typography>
//   </Stack>
// </Box>


//         {/* Processing Details */}
//         <Grid
//           container
//           justifyContent="space-between"
//           alignItems="flex-start"
//           mt={3}
//         >
//           <Grid item>
//             <Typography variant="caption" color="text.secondary">
//               Payment Gateway
//             </Typography>

//             <Typography fontWeight={400} mt={1}>
//               Razorpay
//             </Typography>
//           </Grid>

//           <Grid item textAlign="right">
//             <Typography variant="caption" color="text.secondary">
//               Payment Method
//             </Typography>

//             <Typography fontWeight={400} mt={1}>
//               UPI
//             </Typography>
//           </Grid>
//         </Grid>

//         <Typography variant="caption" color="text.secondary">
//           Timestamp
//         </Typography>
//         <Typography>24 Jun, 2026 — 11:15 AM</Typography>

//         {/* UPI Ref Box */}
//         <Paper
//           sx={{
//             mt: 2,
//             p: 2,
//             borderRadius: 2,
//             bgcolor: "#D3E1F6",
//           }}
//         >
//           <Typography color="primary">UPI Ref ID</Typography>
//           <Typography fontWeight={400}>UPI-8842392</Typography>
//         </Paper>

//         {/* Settlement Box */}
//         <Paper
//           sx={{
//             mt: 2,
//             p: 2,
//             borderRadius: 2,
//             border: "1px solid #cfe9cf",
//           }}
//         >
//           {/* Top Row */}
//           <Stack direction="row" justifyContent="space-between">
//             <Typography fontWeight={400}>Settlement ID: STL-88932</Typography>
//             <Typography style={{ color: "#098963" }}>SETTLED</Typography>{" "}
//           </Stack>

//           {/* Row: Settlement Date (left) & Amount Settled (right) */}
//           <Stack
//             direction="row"
//             justifyContent="space-between"
//             alignItems="flex-start"
//             mt={2}
//           >
//             {/* LEFT: Settlement Date */}
//             <Box>
//               <Typography color="text.secondary">Settlement Date</Typography>
//               <Typography>25 Jun, 2026</Typography>
//               <Typography variant="caption" color="text.secondary">
//                 3:00 PM
//               </Typography>
//             </Box>

//             {/* RIGHT: Amount Settled */}
//             <Box textAlign="right">
//               <Typography color="text.secondary">Amount Settled</Typography>
//               <Typography fontWeight={400}>₹4,890</Typography>
//             </Box>
//           </Stack>
//         </Paper>

//         {/* Buttons */}
//         <Stack direction="column" spacing={2} mt={3}>
//           <Button
//             variant="contained"
//             style={{
//               backgroundColor: "#098963",
//               borderRadius: 8,
//               color: "#fff",
//             }}
//             startIcon={<CloudDownloadIcon />}
//           >
//             Download Tax Invoice
//           </Button>

//           <Button
//             variant="text"
//             style={{ color: "#F30909" }}
//             startIcon={<ErrorOutlineIcon />}
//           >
//             Report Payment Issue
//           </Button>
//         </Stack>
//       </DialogContent>
//     </Dialog>
//   );
// };

// // Reusable row component
// const InfoRow = ({
//   label,
//   value,
// }: {
//   label: string;
//   value: string | number;
// }) => (
//   <Stack direction="row" justifyContent="space-between">
//     <Typography color="text.secondary">{label}</Typography>
//     <Typography fontWeight={400} color="text.secondary">
//       {value}
//     </Typography>
//   </Stack>
// );

// export default PaymentDetails;





import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  Stack,
  Chip,
  Button,
  Paper,
  IconButton,
  Grid,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { WSIcons } from "../../../commonFunctions/iIcons";
import http from "../../../commonFunctions/httpClient";
import { PaymentInvoiceReport } from "./Invoice"; // Adjust path as needed

// INTERFACES - All properly declared
interface OrderSummary {
  orderNumber: string;
  patientName: string;
  orderAmount: number;
  deliveryCharge: number;
  discountApplied: number;
  serviceCharge: number;
  finalPayableAmount: number;
}

interface ProcessingDetails {
  paymentGateway: string | null;
  paymentMethod: string;
  paymentTime: string;
}

interface Reference {
  referenceType: string;
  referenceId: string | null;
}

interface Settlement {
  settlementId: string;
  settlementDate: string;
  amountSettled: number;
  status: string;
}

interface PaymentDetail {
  orderSummary: OrderSummary;
  processingDetails: ProcessingDetails;
  reference: Reference;
  settlement: Settlement;
  canDownloadInvoice: boolean;
  canReportIssue: boolean;
}

interface Props {
  open: boolean;
  onClose: () => void;
  paymentId?: string;
}

const PaymentDetails: React.FC<Props> = ({ open, onClose, paymentId }) => {
  const [paymentDetail, setPaymentDetail] = useState<PaymentDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [showInvoicePreview, setShowInvoicePreview] = useState(false);

  const fetchPaymentDetail = async (id: string) => {
    if (!id) return;
    
    try {
      setLoading(true);
      console.log("🔍 Fetching payment detail for ID:", id);
      const response: any = await http.get(`pharmacy/PhPayment/${id}/details`);
      console.log("📡 Payment detail response:", response);
      
      if (response?.success && response?.data) {
        setPaymentDetail(response.data);
        console.log("✅ Payment detail loaded:", response.data);
      }
    } catch (error) {
      console.error("💥 Error fetching payment details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && paymentId) {
      fetchPaymentDetail(paymentId);
    } else if (!open) {
      setPaymentDetail(null);
      setShowInvoicePreview(false);
    }
  }, [open, paymentId]);

 const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,  // Ensures whole rupees only [web:10][web:11]
  }).format(amount);  // Remove /100 - data is already in rupees [web:17]
};


  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '24 Jun, 2026 — 11:15 AM';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'paid':
        return { color: "#098963", bgColor: "#CEEEE5" };
      case 'pending':
        return { color: "#f57c00", bgColor: "#fff3e0" };
      case 'refunded':
        return { color: "#f44336", bgColor: "#ffebee" };
      default:
        return { color: "#098963", bgColor: "#CEEEE5" };
    }
  };

  const statusStyle = paymentDetail ? getStatusColor(paymentDetail.settlement.status) : { color: "#098963", bgColor: "#CEEEE5" };

  const handleDownloadInvoice = () => {
    if (paymentId) {
      setShowInvoicePreview(true);
    }
  };

  const handleCloseInvoicePreview = () => {
    setShowInvoicePreview(false);
  };

  if (loading) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, maxHeight: "90vh" } }}>
        <DialogContent sx={{ p: 3, textAlign: 'center' }}>
          <Typography>Loading payment details...</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  // Show Invoice Preview Dialog
  if (showInvoicePreview && paymentId) {
    return (
      <Dialog open={true} onClose={handleCloseInvoicePreview} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3, maxHeight: "95vh" } }}>
        <DialogContent sx={{ p: 2, height: "95vh", overflow: "auto" }}>
          <PaymentInvoiceReport paymentId={paymentId} />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "90vh",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 12, right: 12, zIndex: 10 }}
      >
        <WSIcons.AiOutlineCloseSquare color="red" />
      </IconButton>

      <DialogContent sx={{ p: 3 }}>
        {/* Title */}
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight={700}>Payment Details</Typography>
        </Stack>

        {/* Transaction ID & Status */}
        <Typography variant="caption" color="text.secondary">
          {paymentDetail?.orderSummary.orderNumber ? `#${paymentDetail.orderSummary.orderNumber.slice(-8)}` : "#TRORD1095"}
        </Typography>
        <Chip
          label={paymentDetail?.settlement.status?.toUpperCase() || "PAID"}
          size="small"
          sx={{ ml: 2, color: statusStyle.color, backgroundColor: statusStyle.bgColor }}
        />

        <Divider sx={{ my: 2 }} />
        
        {/* FIRST ROW: Patient Name (left) + Order ID (right) */}
        <Box sx={{ border: "1px solid #dcdcdc", borderRadius: 8, p: 2 }}>
          <Stack direction="row" justifyContent="space-between" spacing={3} sx={{ width: "100%" }}>
            {/* LEFT SIDE */}
            <Box sx={{ flex: 1 }}>
              <Typography color="text.secondary" fontSize={13}>
                Patient Name
              </Typography>
              <Typography fontWeight={400} color="text.secondary">
                {paymentDetail?.orderSummary.patientName || "Pharmacy Order"}
              </Typography>
            </Box>

            {/* RIGHT SIDE */}
            <Box sx={{ flex: 1, textAlign: "right" }}>
              <Typography color="text.secondary" fontSize={13}>
                Order ID
              </Typography>
              <Typography fontWeight={400} color="text.secondary">
                {paymentDetail?.orderSummary.orderNumber ? `#${paymentDetail.orderSummary.orderNumber.slice(-8)}` : "#ORD1095"}
              </Typography>
            </Box>
          </Stack>

          <Divider sx={{ mt: 2, mb: 2 }} />

          {/* Payment Info */}
          <Stack spacing={1}>
            <InfoRow label="Order Amount" value={paymentDetail ? formatCurrency(paymentDetail.orderSummary.orderAmount) : "₹0.00"} />
            <InfoRow label="Delivery Charge" value={paymentDetail ? formatCurrency(paymentDetail.orderSummary.deliveryCharge) : "₹40.00"} />
            <InfoRow label="Discount Applied" value={paymentDetail ? `-${formatCurrency(paymentDetail.orderSummary.discountApplied)}` : "- ₹0.00"} />
            <InfoRow label="MELP Service Charge" value={paymentDetail ? formatCurrency(paymentDetail.orderSummary.serviceCharge) : "₹10.00"} />
          </Stack>

          <Divider sx={{ my: 2 }} />

          <Stack direction="row" justifyContent="space-between">
            <Typography fontWeight={400}>Final Payable to Vendor</Typography>
            <Typography fontWeight={700}>
              {paymentDetail ? formatCurrency(paymentDetail.orderSummary.finalPayableAmount) : "₹50.00"}
            </Typography>
          </Stack>
        </Box>

        {/* Processing Details */}
        <Grid container justifyContent="space-between" alignItems="flex-start" mt={3}>
          <Grid item>
            <Typography variant="caption" color="text.secondary">
              Payment Gateway
            </Typography>
            <Typography fontWeight={400} mt={1}>
              {paymentDetail?.processingDetails.paymentGateway || (paymentDetail?.processingDetails.paymentMethod === 'cod' ? 'Cash on Delivery' : 'Razorpay')}
            </Typography>
          </Grid>

          <Grid item textAlign="right">
            <Typography variant="caption" color="text.secondary">
              Payment Method
            </Typography>
            <Typography fontWeight={400} mt={1}>
              {paymentDetail?.processingDetails.paymentMethod === 'cod' ? 'Cash on Delivery' : paymentDetail?.processingDetails.paymentMethod || "UPI"}
            </Typography>
          </Grid>
        </Grid>

        <Typography variant="caption" color="text.secondary">
          Timestamp
        </Typography>
        <Typography>
          {paymentDetail?.processingDetails.paymentTime ? formatDate(paymentDetail.processingDetails.paymentTime) : "24 Jun, 2026 — 11:15 AM"}
        </Typography>

        {/* UPI Ref Box */}
        <Paper sx={{ mt: 2, p: 2, borderRadius: 2, bgcolor: "#D3E1F6" }}>
          <Typography color="primary">
            {paymentDetail?.reference.referenceType === 'cod' ? 'Reference ID' : 'UPI Ref ID'}
          </Typography>
          <Typography fontWeight={400}>
            {paymentDetail?.reference.referenceId || (paymentDetail?.orderSummary.orderNumber ? `UPI-${paymentDetail.orderSummary.orderNumber.slice(-7)}` : "UPI-8842392")}
          </Typography>
        </Paper>

        {/* Settlement Box */}
        <Paper sx={{ mt: 2, p: 2, borderRadius: 2, border: "1px solid #cfe9cf" }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography fontWeight={400}>
              Settlement ID: {paymentDetail?.settlement.settlementId ? `STL-${paymentDetail.settlement.settlementId.slice(-6)}` : "STL-88932"}
            </Typography>
            <Typography style={{ color: "#098963" }}>
              SETTLED
            </Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mt={2}>
            <Box>
              <Typography color="text.secondary">Settlement Date</Typography>
              <Typography>{paymentDetail?.settlement.settlementDate ? formatDate(paymentDetail.settlement.settlementDate) : "25 Jun, 2026"}</Typography>
            </Box>

            <Box textAlign="right">
              <Typography color="text.secondary">Amount Settled</Typography>
              <Typography fontWeight={400}>
                {paymentDetail ? formatCurrency(paymentDetail.settlement.amountSettled) : "₹4,890"}
              </Typography>
            </Box>
          </Stack>
        </Paper>

        {/* Buttons */}
        <Stack direction="column" spacing={2} mt={3}>
          {paymentDetail?.canDownloadInvoice && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#098963",
                borderRadius: 8,
                color: "#fff",
                textTransform: 'none',
                "&:hover": {
                  backgroundColor: "#087654",
                }
              }}
              startIcon={<CloudDownloadIcon />}
              onClick={handleDownloadInvoice}
            >
              Download Tax Invoice
            </Button>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

// Reusable row component
const InfoRow = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography color="text.secondary">{label}</Typography>
    <Typography fontWeight={400} color="text.secondary">
      {value}
    </Typography>
  </Stack>
);

export default PaymentDetails;
